export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9085.7982c32f.jpg";